module.exports = __webpack_public_path__ + "static/media/logotipo_doc_novo.097f68ba.png";